<template>
    <q-btn @mouseover.native="activatorHover = true" @mouseout.native="activatorHover = false"
           no-caps color="grey-2"
           :stretch="isLoggedIn"
           :outline="!isLoggedIn"
           :flat="isLoggedIn"
           @click="isLoggedIn ? null : login()"
           class="text-white"
           :label="isLoggedIn ? '': 'Sign In'"
           :icon="isLoggedIn ? dynamicMenuItems.myAccount.icon : 'mdi-account-arrow-right'">
        <q-menu v-model="menu"
                content-class="no-border no-border-radius">
            <q-list @mouseover.native="menuHover = true" @mouseout.native="menuHover = false"
                    style="min-width: 150px">
                <q-item v-if="isLoggedIn"
                         class="menu"
                        :to="dynamicMenuItems.myAccount.path" v-close-popup>
                    <q-item-section class="q-pa-xs">
                        <q-item-label lines="1">{{ dynamicMenuItems.myAccount.name }}</q-item-label>
                        <q-item-label caption lines="1">
                            {{ user.username }}
                        </q-item-label>
                    </q-item-section>
                </q-item>
                <q-item v-if="isLoggedIn"
                         class="menu"
                        clickable @click="logout()" v-close-popup>
                    <q-item-section class="q-pa-xs">
                        <q-item-label>Sign Out</q-item-label>
                    </q-item-section>
                </q-item>
            </q-list>
        </q-menu>
        <q-dialog v-model="showLoginDialog">
            <login @close="showLoginDialog = false;" style="width: 100%; max-width: 375px;"/>
        </q-dialog>
    </q-btn>
</template>

<script>
    import { debounce } from 'quasar';
    import { dynamicMenuItems } from '@/plugins/menuItems'
    import login from '@/components/Login'

    export default {
        name: 'account-menu',
        components: {
            login,
        },
        props: {
            hover: Boolean,
            showLogin: Boolean,
            debounceTime: {
                type: Number,
                default: 50,
            },
        },
        data() {
            return {
                showLoginDialog: false,
                menu: false,
                activatorHover: false,
                menuHover: false,
                debounceMenu: null,
                dynamicMenuItems: dynamicMenuItems
            };
        },
        methods: {
            checkMenu() {
                if (this.hover)
                    this.menu = this.activatorHover || this.menuHover;
            },
            logout() {
                this.$store.dispatch('logout')
                this.$router.push({ name: '/home' })
            },
            login() {
                this.showLoginDialog = true
            },
        },
        computed: {
            isLoggedIn() { return this.$store.getters.isLoggedIn },
            user() { return this.$store.getters.authUser },
        },
        watch: {
            menuHover() {
                this.debounceMenu();
            },
            activatorHover() {
                this.debounceMenu();
            },
            isLoggedIn(newVal) {
                if (newVal) this.showLoginDialog = false
            },
            showLogin(newVal) {
                this.showLoginDialog = newVal
            },
            showLoginDialog(newVal) {
                if (!newVal) this.$emit('close')
            },
        },
        created() {
            this.debounceMenu = debounce(this.checkMenu, this.debounceTime);
            if (!this.isLoggedIn && this.$route.query.login) {
                this.login();
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../styles/quasar.variables.scss";

    .menu {
        border-left: 2px solid transparent;
    }

    .menu:hover {
        border-left: 2px solid $primary !important;
    }
</style>
